<script setup lang="ts">
import MdiFaIcon from '../MdiFaIcon.vue';
import { Details } from '../types/share';
import { useDisplay } from 'vuetify';

type Props = {
  item: Details;
  rounded?: boolean;
  detailIconSize?: number | string;
};
withDefaults(defineProps<Props>(), {
  detailIconSize: 24,
});
const { smAndDown } = useDisplay();
</script>

<template>
  <v-card
    flat
    :style="rounded ? 'border-radius: 10px' : 'border-radius: 6px'"
    class="d-flex ga-1 justify-start align-center flex-column share-detail flex-shrink-0 flex-md-row justify-md-start"
    :class="smAndDown ? 'px-3 py-1' : 'pa-3'"
    :color="item.bgColor"
  >
    <div v-if="item.icon !== ''">
      <MdiFaIcon
        :icon="item.icon"
        :color="item.fontColor ?? 'currentColor'"
        :size="detailIconSize"
        :fixed-width="true"
        v-bind="item.iconProps"
      />
    </div>
    <v-sheet width="100%" min-width="0" class="bg-transparent d-flex flex-column align-center align-md-start">
      <p class="share-detail-text d-inline-block">
        {{ item.title }}
      </p>
      <p
        class="share-detail-text d-inline-block"
        :class="{ 'on-surface-medium': item.title }"
        :style="item.title ? 'font-size: 12px' : 'font-size: 14px'"
      >
        {{ typeof item.value === 'function' ? item.value() : item.value }}
      </p>
    </v-sheet>
  </v-card>
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'vuetify/settings' as v;

.share-detail {
  &-text {
    font-size: 12px;

    @media #{map.get(v.$display-breakpoints, 'md-and-up')} {
      min-width: 0;
      max-width: 100%;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-left: 8px;
    }
  }

  @media #{map.get(v.$display-breakpoints, 'md-and-up')} {
    width: calc(50% - 4px);
  }
}
</style>
